import {matchRoutes, RouteMatch, RouteObject, useLocation} from "react-router-dom";
import {routes} from "@/routes.tsx";

export const getLongestMatch = (matches: RouteMatch<string, RouteObject>[] | null) => {
    let resultMatch: RouteMatch<string, RouteObject> | null;
    if (matches == null || matches.length === 0) {
        resultMatch = null
    } else if (matches.length === 1) {
        resultMatch = matches[0]
    } else {
        resultMatch = matches[0]
        for (let match of matches) {
            if (match.route.path && resultMatch.route.path && match.route.path.length > resultMatch.route.path.length) {
                resultMatch = match
            }
        }
    }
    return resultMatch
}

export const useCurrentPath = () => {
    const location = useLocation()
    const matches = matchRoutes(routes, location)
    let resultMatch = getLongestMatch(matches)
    if (resultMatch) return resultMatch.route.path
    return null
}